var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"custom-select",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit("input", $event.target.value)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }